import React, { useEffect } from "react";
import { Cards } from "../../../../components/cards/frame/cards-frame";
import { UserTableStyleWrapper } from "../../../pages/style";
import { TableWrapper } from "../../../styled";
import CarsGrid from "../../../../container/car/grid";

const Tab2 = (props) => {
  const { t, selectedItem, onTitleUpdate } = props;

  const cars = selectedItem?.cars || [];

  useEffect(() => {
    // Update tab title with car count
    if (typeof onTitleUpdate === "function") {
      onTitleUpdate(`${t("car.cars")} (${cars.length})`);
    }
  }, [cars.length, onTitleUpdate, t]);

  // POZOR, odstranene 5.10.2026. Bolo tu:
  //   useEffect(() => { dispatch(setAllCars(branchOfficceData)); ... },
  //             [branchOfficceData])
  // Dve chyby naraz. Po prve sa do spolocneho uloziska vozidiel zapisovali
  // auta jednej pobocky, takze zoznam na /admin/car ukazal podmnozinu.
  // Po druhe sa pole `branchOfficceData` vyrabalo nanovo pri kazdom
  // prekresleni, takze efekt bezal donekonecna, dispatch vyvolal dalsie
  // prekreslenie a stranka sa zasekla na prazdnej obrazovke.
  // Zoznam vozidiel si CarsGrid nizsie taha sam podla pobocky.


  return (
    <Cards headless>
      {/* Predtym tu bolo vlastne policko na hladanie, ktore len plnilo
          napovedu a tabulku nikdy nefiltrovalo, a zoznam pod nim ukazoval
          NEAKTIVNE vozidla vsetkych pobociek. Teraz je to zoznam vozidiel
          tejto pobocky aj s vlastnym hladanim a filtrami. */}
      <UserTableStyleWrapper>
        <TableWrapper className="table-responsive">
          <CarsGrid active pevnaPobocka={Number(selectedItem?.id)} t={t} />
        </TableWrapper>
      </UserTableStyleWrapper>
    </Cards>
  );
};

export { Tab2 };
